import '../index.css';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import {
  AppBar,
  Button,
  NativeSelect,
  Toolbar,
  Typography,
} from '@material-ui/core';

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  grow: {
    flexGrow: 1,
  },
  select: {
    marginLeft: theme.spacing(3),
  },
}));

const darkTheme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: green[700],
    },
  },
});

export const DashboardToolbar = ({
  updateCurrentDiningHall,
  diningHallPretty,
  diningHalls,
  signOut,
}) => {
  const classes = useStyles();

  const handleChange = (event) => {
    const selectedIndex = event.target.options.selectedIndex;
    updateCurrentDiningHall(
      event.target.options[selectedIndex].getAttribute('data-key'),
      event.target.value
    );
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6">DeWaste Dashboard</Typography>

          <NativeSelect
            className={classes.select}
            value={diningHallPretty}
            onChange={handleChange}
          >
            <option value="" disabled>
              Dining Hall Name
            </option>
            {Object.entries(diningHalls).map(([diningHall, diningHallDoc]) => {
              return (
                <option key={diningHall} data-key={diningHall}>
                  {diningHallDoc.name}
                </option>
              );
            })}
          </NativeSelect>

          <div className={classes.grow} />

          <Button
            className={classes.menuButton}
            color="inherit"
            aria-label="menu"
            onClick={signOut}
            variant="outlined"
          >
            Log Out
          </Button>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
};
